const offset = 100;

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault();
		console.log('123');
		const targetId = this.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const targetPosition =
				targetElement.getBoundingClientRect().top +
				window.pageYOffset -
				offset;
			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth',
			});
		}
	});
});
